import React from 'react'
import {Link, withRouter} from 'react-router-dom'
import ImgBanner from '../../assets/img/bg_header.png'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import query from '../../util/urlUtil';
import '../../assets/style/home.scss';
import {MobileStepper} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {KeyboardArrowLeft, KeyboardArrowRight} from "@material-ui/icons";
import {getStaticResource} from "../../api/developer";

class Home extends React.Component {

    state = {
        open: false,
        activeStep: 0,
        errorText: '',
        stepContent: []
    };
    timer = null;

    componentDidMount() {
        let error = query('error');
        if (error) {
            switch (error) {
                case 'access_denied':
                    this.setState({errorText: 'Sorry, you are not allowed to access this application'});
                    break;
                default:
                    this.setState({errorText: 'Unexpected error occurred'});
                    break;
            }
            this.setState({open: true});
        }

        getStaticResource("/news/news-config.json")
            .then((res) => this.setState({stepContent: res.data}));


        this.timer = setInterval(() => {
            if (this.state.activeStep !== this.state.stepContent.length - 1) {
                this.setState({activeStep: this.state.activeStep + 1})
            } else {
                this.setState({activeStep: 0})
            }
        },10000)
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    handleClose = () => {
        this.setState({open: false});
        this.props.history.push('/');
    };

    render() {

        const {errorText} = this.state;
        const year = new Date().getFullYear();

        const handleNext = () => {
            this.setState({activeStep: this.state.activeStep + 1});
        };

        const handleBack = () => {
            this.setState({activeStep: this.state.activeStep - 1});
        };

        return (
            <div className="root-all bg-white">
                <div className={"header-main-container"}>
                    <div className={"header-main-container__left"}>
                        <div className={"header-main-container__left__text__parent"}>
                            <p>
                                <span className={"header-main-container__left__text__parent__title"}>
                                     Banking with BIL ?&nbsp;
                                 </span>
                                <span className={"header-main-container__left__text__parent__title"}
                                      style={{color: "#D6246E"}}>
                                    We are open !
                                </span>
                            </p>
                            <p className={"header-main-container__left__text__parent__subtitle_1"}>
                                Build new digital experiences using the BIL secure Open Banking API.
                            </p>
                            <p className={"header-main-container__left__text__parent__subtitle_2"}>
                                Welcome to the future of financial services ! BIL is committed to Open Banking and empowers developers to build innovative financial application through our secure and robuste API.
                            </p>
                        </div>
                    </div>
                    <img className={"header-main-container__right"} alt={"BIL Banner"} src={ImgBanner}/>
                </div>

                <div className={"get-started-main-container"}>
                    <div className={"get-started-main-container__left"}>
                        <p className={"get-started-main-container__title"}>
                            Get started !
                        </p>
                        <p className={"get-started-main-container__subtitle_1"}>
                            You are a Third party provider
                        </p>
                        <p className={"get-started-main-container__subtitle_2"}>
                            Build new digital experiences using the BIL secure Open Banking API.
                        </p>
                        <div>
                            <Link to="/get-started-v2" className="btn btn-small btn-green">
                                <span style={{fontSize: "14px"}}>Start as TPP</span>
                            </Link>
                        </div>
                    </div>

                    <div className={"get-started-main-container__right"}>
                        <p className={"get-started-main-container__title"}>
                            API Catalog !
                        </p>
                        <p className={"get-started-main-container__subtitle_1"}>
                            Select your API
                        </p>
                        <p className={"get-started-main-container__subtitle_2"}>
                            Explore our comprehensive API Catalog and unlock powerful integrations.
                        </p>
                        <div>
                            <Link to="/catalog" className="btn btn-small btn-green">
                                <span style={{fontSize: "14px"}}>Browse our APIs</span>
                            </Link>
                        </div>
                    </div>

                </div>

                <div className={"what-is-new-main-container"}>
                    <p className={"what-is-new-main-container__title"}>
                        What is new ?
                    </p>
                    <p className={"what-is-new-main-container__subtitle"}>
                        Discover the latest enhancements and updates of BIL's Open Banking platform.
                    </p>
                </div>

                {this.state.stepContent.length > 0 ?
                    <div className={"what-is-new-carrousel-main-container"}>
                        <div className={"what-is-new-carrousel-main-container__carrousel"}>
                            <img className={"what-is-new-carrousel-main-container__img"}
                                 src={`${window.portalBaseUrl}/news/img/${this.state.stepContent[this.state.activeStep].staticResource}`}
                                 alt={this.state.stepContent[this.state.activeStep].label}
                            />
                            <MobileStepper
                                steps={this.state.stepContent.length}
                                position="static"
                                variant="text"
                                activeStep={this.state.activeStep}
                                nextButton={
                                    <Button size="small" onClick={handleNext}
                                            disabled={this.state.activeStep === this.state.stepContent.length - 1}>
                                        <KeyboardArrowRight/>
                                    </Button>}
                                backButton={
                                    <Button size="small" onClick={handleBack} disabled={this.state.activeStep === 0}>
                                        <KeyboardArrowLeft/>
                                    </Button>}
                            />
                        </div>
                    </div> : null
                }


                <section className="section-footer text-center">
                    <p>Copyright © {year} - Banque Internationale à Luxembourg SA All rights reserved.</p>
                </section>

                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {errorText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <button className="btn btn-small btn-blue" onClick={this.handleClose}>ok</button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default withRouter(Home)
